import { useContext, useEffect, useState } from "react";
import { getSession } from "next-auth/client";
import { toStaticMarkup, getShorthand, GA_onLoadContent, LOCK_REASON, VirtualUrlContext,AppContext } from "@app/utils";
import { useRouter } from "next/router";
//import cookies from 'next-cookies';
import { getArticle, trimBodyContent, TRIM_REASONS, SEARCH_START, subscriptionCheck, getPreviewLockStatus, RELATED_LOADMORE_ROWS, RELATED_MAX_FETCH } from "@app/utils";
import {
  Container,
  Column,
  MobileInsertAd,
  ArticleHeader,
  ArticleImage,
  ArticleContent,
  ArticleSource,
  ArticleFooter,
  Feedback,
  SocialShare,
  LoadMoreSection,
  PayWall,
  Seo
} from "@app/components";
import queryString from 'query-string'

//376997 is always open, 376988 is subscriber only, 376995 is null
/*
    -   NotLocked	The content item is opened. e.g. The user has a valid subscription or it is marked as Pubilc in the CMS
    -   Trialing	The content item is opened. e.g. user still have reading quota
    -   TrialEnded	The content item is locked. e.g. user used up all the reading quota
    -   NoSubscription	The content item is locked. e.g. current user does not have a valid subscription.
    -   DomainBlacklisted	The content item is locked. e.g. the primary and all the work email domains are on the blacklisted domain
*/
// no login 

export async function getServerSideProps(context) {
  var { params, query, res, req } = context;
  let session = await getSession(context);
  let combinedStr = "";
  // uat special redirect for event website 

  const result = await getArticle(params.id, query.preview);
  if (!result || result?.status !== 200) {
    return {
      notFound: true,
    };
  }
  const { data } = result;
  let subscriptionStatus = getPreviewLockStatus();
  if(data?.isPreview===false)
    subscriptionStatus = await subscriptionCheck(data?.summary?.lockStatus, parseInt(params.id), session, res, req);
  

  if (data?.pages.length > 0) {
    data.pages.forEach((page) => {
      combinedStr += page;
    });
    if (TRIM_REASONS.includes(subscriptionStatus.lockReason)) {
      combinedStr = trimBodyContent(combinedStr)
    }
  }
  return {
    props: {
      params,
      postData: { ...data, body: await toStaticMarkup(combinedStr) },
      subscriptionStatus: subscriptionStatus,
      session: session
    },
  };
  
}


export default function Post({ params, postData, session, subscriptionStatus }) {
  const router = useRouter();

  const { summary, body, source } = postData;
  const partner =
    summary?.categoryNames &&
    summary.categoryNames.some(
      (categoryName) => categoryName.toLowerCase() === "partner content"
    );

  const shorthand = getShorthand(body);
  const [ virtualUrl, setVirtualUrl ] = useContext(VirtualUrlContext)
  const {val2} = useContext(AppContext)
  const [aId, setAId] = val2
  setAId(params.id)
  
    const [advertisementBrands, setAdvertisementBrands] = val2
      setAdvertisementBrands(summary.advertisementBrands);
  
  useEffect(() => {
    // Handle tracking for content pages
    let userId = session?.token?.sub || '0'
    setVirtualUrl(GA_onLoadContent(subscriptionStatus, summary, source, userId))
    
    const payload = {
      'user_id': userId,
      lock_reason: subscriptionStatus.lockReason
    }

    window.divolte?.signal('pageView', payload)
  }, [ postData ])
  
  //console.log('lock info:',summary.lockStatus, subscriptionStatus)

  const MainSection = () => (
    <>
      <ArticleHeader {...summary} body={body} />
      <ArticleImage {...summary} lockReason={subscriptionStatus.lockReason} />
      {/* Ad for Mobile */}
      <MobileInsertAd />
      <ArticleContent body={body} />
      <PayWall {...subscriptionStatus} />
      <ArticleSource source={source} />
    </>
  );

  const MainBottomSection = () => (
    <ArticleFooter {...summary} />
  )

  const LeftSection = () => (
    <>
      <Column variant='side'>
        <Feedback
          session={session}
          url={`${process.env.NEXT_PUBLIC_API_URL}${router.asPath}`}
        />
      </Column>
      <Column variant='side'>
        <SocialShare
          title={summary && summary.heading}
          url={`${process.env.NEXT_PUBLIC_API_URL}${router.asPath}`}
        />
      </Column>
    </>
  );
  // console.log(postData)

  return (
    <>
      <Seo.Article summary={summary} />
      {shorthand ? <div dangerouslySetInnerHTML={{ __html: body }} className='shorthand-embed | tw--my-4 | sm:tw--my-8 | lg:tw--my-12 | 2xl:tw--my-16' suppressHydrationWarning={true} /> :
        <Container
          googleAd
          center={<MainSection />}
          centerBottom={<MainBottomSection />}
          left={<LeftSection />}
          partner={partner}
        />
      }
      {params?.id && (
        <LoadMoreSection
          googleAd
          key={`loadmore-article-${params.id}`}
          id={params.id}
          loadArticles={true}
          rows={RELATED_LOADMORE_ROWS}
          maxFetch={RELATED_MAX_FETCH}
          pagingData={{ start: SEARCH_START }}
          func="getRelatedArticles"
          title="Related Articles"
          summary={summary}
          subscriptionStatus={subscriptionStatus}
          userId={session?.token?.sub || '0'}
        />
      )}
    </>
  );
}
